// SkipJobChooserPage — /skip/jobs/new
//
// Three-card landing page that replaces the legacy book_skip.php chooser.
// SKIP_MODULE_PLAN §7.12's "chooser dropped" decision was reversed during
// the rebuild — the chooser now lives at /skip/jobs/new and is the
// destination of the SkipNav "New Job" link if/when one is added; the
// existing direct routes (/skip/jobs/create, /skip/enquiries/create,
// /skip/jobs/active) remain valid for callers that already know which
// flow they want.

import { ClipboardList, RefreshCw, Truck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from '../../../components/ui/PageHeader/PageHeader';

import styles from './SkipJobChooserPage.module.css';

interface ChooserCardProps {
  icon: typeof ClipboardList;
  heading: string;
  body: string;
  onClick: () => void;
  testId: string;
}

function ChooserCard({
  icon: Icon,
  heading,
  body,
  onClick,
  testId,
}: ChooserCardProps): JSX.Element {
  return (
    <button
      type="button"
      className={styles.card}
      onClick={onClick}
      data-testid={testId}
    >
      <span className={styles.iconCircle} aria-hidden>
        <Icon size={22} />
      </span>
      <span className={styles.heading}>{heading}</span>
      <span className={styles.body}>{body}</span>
    </button>
  );
}

export function SkipJobChooserPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <PageHeader title="New Job" subtitle="Choose how to start" />
      <div className={styles.cards}>
        <ChooserCard
          icon={ClipboardList}
          heading="Add Enquiry"
          body="Capture a new lead or customer enquiry"
          onClick={() => navigate('/skip/enquiries/create')}
          testId="chooser-enquiry"
        />
        <ChooserCard
          icon={Truck}
          heading="Create Job"
          body="Book a new skip job directly"
          onClick={() => navigate('/skip/jobs/create')}
          testId="chooser-create"
        />
        <ChooserCard
          icon={RefreshCw}
          heading="Update Active Job"
          body="Process a collection, exchange, or tip & return on an existing job"
          onClick={() => navigate('/skip/jobs/active')}
          testId="chooser-active"
        />
      </div>
    </div>
  );
}
